import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="form-validation"
// Validates credit card forms with standard rules
export default class extends Controller {
  connect() {
    // Wait for validate plugin to be available
    this.waitForValidate(() => {
      this.initializeValidation()
    })
  }

  waitForValidate(callback) {
    if (window.$.fn.validate) {
      callback()
    } else {
      setTimeout(() => this.waitForValidate(callback), 50)
    }
  }

  initializeValidation() {
    const $form = window.$(this.element)

    $form.validate({
      rules: {
        cardnumber: {
          creditcard: true
        },
        cvvnumber: {
          digits: true,
          minlength: 3,
          maxlength: 4
        },
        expdate: {
          minlength: 5,
          maxlength: 5
        }
      },
      messages: {
        cvvnumber: {
          digits: "3 digits",
          minlength: "3 digits",
          maxlength: "4 digits"
        },
        expdate: {
          minlength: "Format: MM/YY",
          maxlength: "Format: MM/YY"
        },
        cardnumber: {
          creditcard: "Not a valid card number"
        }
      }
    })
  }
}
